profileApp.controller('companiesPlansCtrl', function (
    $scope,
    $state,
    $rootScope,
    $timeout,
    $filter,
    temporaryData,
    plansSearchService,
    tenderStatesListService,
    ntFlash,
    searchBookmarksService,
    $mdDateLocale
) {

    var planStatuses = [
        {
            title: gettext("Черновик"),
            value: "draft"
        },
        {
            title: gettext("Запланирован"),
            value: "scheduled"
        },
        {
            title: gettext("Отменен"),
            value: "cancelled"
        },
        {
            title: gettext("Завершен"),
            value: "complete"
        },
        {
            title: gettext("Тендер отменен"),
            value: "unsuccessful"
        }
    ];

    $scope.requestInProgress = true;
    $scope.hidePagination = true;
    $scope.itemsPerPage = 10;
    $scope.itemsPerSeacrhPage = 10;
    $scope.isSearchFieldFocused = false;

    var currentPage = $state.params.pageNum,
        cpvFiltersList = $state.params.cpv || '',
        dkppFiltersList = $state.params.dkpp || '';

    $scope.classifiers = temporaryData.get('searchableClassifiers') || [];

    $scope.searchList = {
        statusesAmount: 0,
        procurementMethodTypesAmount: 0,
        statuses: planStatuses,
        procurementMethodTypes: tenderStatesListService.getProcurementMethodTypesList()
    };

    $scope.dateEdit = function (date) {
        const d = new Date(date);
        const m = ('0' + (d.getMonth() + 1)).slice(-2);
        const day = ('0' + d.getDate()).slice(-2);
        return d.getFullYear() + '-' + m + '-' + day;
    };

    $scope.statuses = $state.params.status ? $state.params.status.split(',') : [];
    $scope.PMTypes = $state.params.procurementMethodType ? $state.params.procurementMethodType.split(',') : [];

    // Format date for md-datepicker
    $mdDateLocale.formatDate = date => {
        var res = $filter('date')(date, "yyyy/MM/dd");
        return res;
    };
    $scope.create_gte = $state.params.create_gte ? $state.params.create_gte : null;
    $scope.create_lte = $state.params.create_lte ? $state.params.create_lte : null;
    $scope.tp_gte = $state.params.tp_gte ? $state.params.tp_gte : null;
    $scope.tp_lte = $state.params.tp_lte ? $state.params.tp_lte : null;

    $scope.searchData = {
        type: $state.params.type,
        edrpou: $state.params.edrpou,
        pageNum: $state.params.pageNum,
        query: $state.params.query || '',
        status: $state.params.status || '',
        procurementMethodType: $state.params.procurementMethodType || '',
        cpv: $state.params.cpv || '',
        dkpp: $state.params.dkpp || '',
        amount_gte: $state.params.amount_gte ? +$state.params.amount_gte : '',
        amount_lte: $state.params.amount_lte ? +$state.params.amount_lte : '',
        create_gte: $state.params.create_gte ? $scope.dateEdit($state.params.create_gte) : '',
        create_lte: $state.params.create_lte ? $scope.dateEdit($state.params.create_lte) : '',
        tp_gte: $state.params.tp_gte ? $scope.dateEdit($state.params.tp_gte) : '',
        tp_lte: $state.params.tp_lte ? $scope.dateEdit($state.params.tp_lte) : ''
    };

    plansSearchService.get($scope.searchData)
        .then(result => {
            console.log('result', result);
            var itemsPerPage;
            $scope.plans = result.data;
            $scope.pagerItemsPerPage = $scope.plans.length;
            $scope.totalPages = result.total_pages;
            $scope.totalItems = result.total_items;
            itemsPerPage = $scope.itemsPerSeacrhPage;
    
            $scope.hidePagination = (function () {
                return Boolean($scope.totalItems <= $scope.itemsPerPage);
            })();

            $scope.paginationLabel = (function () {
                var startAt = (currentPage > 1) ?
                    ((currentPage - 1) * $scope.itemsPerPage) + 1 : 1;
    
                var endAt = ((startAt + $scope.itemsPerPage - 1) <= $scope.totalItems) ?
                    startAt + $scope.itemsPerPage - 1 : startAt + ($scope.totalItems - startAt);
    
                return startAt.toString() + "-" + endAt.toString() + ' ' + gettext('из') + ' ' + $scope.totalItems;
            })();
    
            temporaryData.set('paginationLabel', $scope.paginationLabel);
    
            $scope.requestInProgress = false;
            $scope.currentPage = currentPage;
            $scope.prevPage = Number(currentPage) <= 1 ? '1' : (currentPage - 1).toString();
            $scope.nextPage = $scope.pagerItemsPerPage < itemsPerPage ? $scope.currentPage.toString() : (Number(currentPage) + 1).toString();
        });

    function updateSearchData() {

        $scope.searchData.status = $scope.statuses.join(',');
        $scope.searchData.procurementMethodType = $scope.PMTypes.join(',');

        $scope.searchData.create_gte = $scope.create_gte ? $scope.dateEdit($scope.create_gte) : '';
        $scope.searchData.create_lte = $scope.create_lte ? $scope.dateEdit($scope.create_lte) : '';
        $scope.searchData.tp_gte = $scope.tp_gte ? $scope.dateEdit($scope.tp_gte) : '';
        $scope.searchData.tp_lte = $scope.tp_lte ? $scope.dateEdit($scope.tp_lte) : '';
        $scope.searchData.pageNum = '1';
    }

    $scope.search = function () {
        updateSearchData();

        $state.go('profile.companies.plans.type', $scope.searchData, {
            reload: true,
            inherit: false
        });
        $scope.searchData.createReport = '';
    };

    $scope.clearSearchData = function () {
        $scope.classifiers = [];
        $scope.PMTypes = [];
        $scope.statuses = [];
        temporaryData.set('searchableClassifiers', $scope.classifiers);
        cpvFiltersList = '';
        dkppFiltersList = '';
        $state.go('profile.companies.plans.type', {
            type: $state.params.type,
            edrpou: $state.params.edrpou,
            pageNum: 1,
            query: '',
            status: '',
            procurementMethodType: '',
            cpv: '',
            dkpp: '',
            amount_gte: '',
            amount_lte: '',
            create_gte: '',
            create_lte: '',
            tp_gte: '',
            tp_lte: ''
        }, {
            reload: true
        });
    };

    $scope.createReport = function () {
        updateSearchData();
        $scope.searchData.createReport = '1';
        ntFlash.success(gettext('Отчет будет доступен в профиле в разделе Отчеты'));
        plansSearchService.get($scope.searchData);
    };

    $scope.canCreateReport = function () {
        return !$rootScope.isAnonymous;
    };

    /**
     * Create filtered request and draw list of classifiers.
     * @param event
     * @param classifier - selected classifiers list
     * @param type - 'cpv' or 'dkpp'
     */

    $scope.openClassifier = function(classifiersName) {
        let currentState = $state.current.name;
        let slassifierScheme;
        switch (classifiersName) {
            case 'cpv': slassifierScheme = 'ДК021'; break;
            case 'dkpp': slassifierScheme = 'ДКПП'; break;
            case 'inn': slassifierScheme = 'INN'; break;
        }

        let addClasificatorsDestroy = $rootScope.$on('addClasificators',  function(event, classifier, type) {
            let preClassifiers = $scope.classifiers.filter(el => el.scheme !== slassifierScheme);
            $scope.classifiers = preClassifiers;
            (classifier || []).forEach(el => {
                $scope.classifiers.push(el)
            });

            temporaryData.set('searchableClassifiers', $scope.classifiers);

            cpvFiltersList = '';
            dkppFiltersList = '';

            $scope.classifiers.forEach(function (val) {
                switch (val.scheme) {
                    case 'ДК021': cpvFiltersList += val.code + ',';
                                  break;
                    case 'ДКПП':  dkppFiltersList += val.code + ',';
                                  break;
                }
            });

            cpvFiltersList = cpvFiltersList.substring(0, cpvFiltersList.length - 1);
            dkppFiltersList = dkppFiltersList.substring(0, dkppFiltersList.length - 1);

            $scope.searchData.cpv = cpvFiltersList;
            $scope.searchData.dkpp = dkppFiltersList;

            addClasificatorsDestroy();
            closeClasificatorsDestroy();
            $state.go(currentState);
        });

        let closeClasificatorsDestroy = $rootScope.$on('closeClasificators', function () {
            addClasificatorsDestroy();
            closeClasificatorsDestroy();
            $state.go(currentState);
        });

        $state.go(`${currentState}.${classifiersName}`);
    }

    $scope.choosePrivacy = function () {
        if ($scope.searchData.bidderOnly) {
            $state.params.bidderOnly = $scope.searchData.bidderOnly.toString();
        } else if ($state.params.userOnly) {
            $state.params.userOnly = $scope.searchData.userOnly.toString();
        }
    };

    // $scope.deleteFilter = function (index) {
    //     $scope.classifiers.splice(index, 1);
    //     addClassifier(null, [], null);
    // };

    $scope.setIsSearchFieldFocused = (val) => {
        $timeout(() => $scope.isSearchFieldFocused = val, 200);
    };

    $scope.showSearchBookmarks = !$rootScope.isAnonymous;

    if ($scope.showSearchBookmarks) {
        getNewBookmarkName = (n) => {
            n = n > 0 ? n : 1;
            return gettext("Мой поиск") + " # " + n;
        };
        $scope.hasSavedBookmarks = false;
        $scope.newBookmarkName = getNewBookmarkName(1);

        searchBookmarksService.getList()
            .then((bookmarksList) => {
                $scope.bookmarksList = bookmarksList;
                $scope.bookmarksCount = bookmarksList.length > 0 ? bookmarksList.length : 0;
                $scope.hasSavedBookmarks = $scope.bookmarksCount > 0;
                $scope.newBookmarkName = getNewBookmarkName($scope.bookmarksCount + 1);
            });

        $scope.deleteBookmark = (bookmarkId) => {
            if (bookmarkId) {
                searchBookmarksService.delete(bookmarkId)
                    .then(() => {
                        searchBookmarksService.getList()
                            .then((bookmarksList) => {
                                $scope.bookmarksList = bookmarksList;
                                $scope.newBookmarkName = getNewBookmarkName($scope.bookmarksCount);
                                $scope.bookmarksCount = bookmarksList.length > 0 ? bookmarksList.length : 0;
                                $scope.hasSavedBookmarks = $scope.bookmarksCount > 0;
                            });
                    });
            }
        };

        let getBookmarkData = (id) => {
            return $scope.bookmarksList.find(bookmark => bookmark.id === id);
        };

        $scope.setBookmarkSearchData = (bookmarkId) => {
            $scope.showOptions = true;
            let bookmarkData = getBookmarkData(bookmarkId);
            if (bookmarkData && bookmarkData.flags) {
                let params = bookmarkData.flags;
                $scope.searchData = bookmarkData.flags;
                $scope.statuses = params.status ? params.status.split(',') : [];
                $scope.PMTypes = params.procurementMethodType ? params.procurementMethodType.split(',') : [];
                $scope.classifiers = params.cpv ? params.cpv.split(',').map(code=>{ return {code:code,name:''}; }) : [];
                $scope.create_gte = params.create_gte ? params.create_gte : null;
                $scope.create_lte = params.create_lte ? params.create_lte : null;
                $scope.tp_gte = params.tp_gte ? params.tp_gte : null;
                $scope.tp_lte = params.tp_lte ? params.tp_lte : null;
                temporaryData.set('searchableClassifiers', $scope.classifiers);
            }
        };

        $scope.saveSearchBookmark = () => {
            updateSearchData();
            $scope.bookmarksCount++;
            searchBookmarksService.save($scope.searchData, $scope.newBookmarkName)
                .then(() => {
                    searchBookmarksService.getList()
                        .then((bookmarksList) => {
                            $scope.bookmarksList = bookmarksList;
                            $scope.newBookmarkName = getNewBookmarkName($scope.bookmarksCount + 1);
                            ntFlash.success(gettext('Поиск сохранен') + ': ' + ($scope.bookmarksCount));
                            $scope.bookmarksCount = bookmarksList.length > 0 ? bookmarksList.length : 0;
                            $scope.hasSavedBookmarks = $scope.bookmarksCount > 0;
                        });
                });
        };
    }
    $scope.closeSelectBox = () => {
        $("md-backdrop").trigger ("click");
    };
});